export let replySubjectPrefix = "kpUB0";
export let forwardSubjectPrefix = "HekbN";
export let approveSubjectPrefix = "VZegxe";
export let rejectSubjectPrefix = "DJYOee";
export default {replySubjectPrefix,forwardSubjectPrefix,approveSubjectPrefix,rejectSubjectPrefix};